const BASE_API_URL = "koboeat-api.localhost/api/v1/"

const getTenantId = () => {
    let host = window.location.host;
    let parts = host.split('.');
    let subDomainLength = 3; // without www
    let wwwSubDomainLength = 4; // with www

    if(window.location.hostname === 'localhost'){
        return 'app.'
    }

    if(parts.length === subDomainLength && parts[0] !== 'www'){
        return parts[0] + "."
    }else if(parts.length === wwwSubDomainLength && parts[0] === 'www'){
        return parts[1] + "."
    }

    if(parts[0] && parts[0] !== "www"){
        return parts[0] + "."
    }

    return window.location.hostname === 'localhost' ? 'app.' : ""
}

export function isSubdomain(url){
    url = url.replace('http://', '') // replace http://
    url = url.replace('https://', '') // replace https://
    let parts = url.split('.')

    let isSubdomain = false

    let subDomainLength = 3; // without www
    let wwwSubDomainLength = 4; // with www

    if(parts.length === subDomainLength && parts[0] !== 'www'){
        isSubdomain = true
    }else if(parts.length === wwwSubDomainLength && parts[0] === 'www'){
        isSubdomain = true
    }

    return isSubdomain
}

export const BASE_URL = "http://" + getTenantId() + BASE_API_URL;
